import stringSimilarity from 'string-similarity'

// const defineIsNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)

const required = value => {
  const errorText = "Це поле є обов'язковим"

  if (!value) return errorText

  const isBlob = value instanceof Blob
  const isFile = value instanceof File

  if (isBlob || isFile) {
    return Boolean(value.name) || errorText
  }

  if (typeof value === 'number') return true

  if (typeof value === 'string') {
    return Boolean(value.trim().length) || errorText
  }

  if (Array.isArray(value)) {
    return Boolean(value.length) || errorText
  }

  if (typeof value === 'object') {
    return Boolean(Object.keys(value).length) || errorText
  }

  if (typeof value === 'boolean') {
    return value || errorText
  }
}

// const numeric = value =>
//   value ? defineIsNumeric(value) || 'Це поле є некоректним' : true;

// const positive = value =>
//   value ? Number(value) > 0 || 'Це поле має бути позитивним' : true;

const counter = (value, max) =>
  !value || value.length <= max || `Максимум ${max} символів`

// const between = (value, min, max) =>
//   value
//     ? Number(value) < min || Number(value) > max
//       ? `Значення повинно бути між ${min} та ${max}`
//       : true
//     : true;

const popularDomains = ['gmail.com', 'ukr.net']

const email = value => {
  if (!value) return true

  const v = String(value).trim()
  const isValidFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
  if (!isValidFormat) return 'Необхідна повна адреса електронної пошти'

  const [local, rawDomain = ''] = v.split('@')
  const domain = rawDomain.toLowerCase()

  const { bestMatch } = stringSimilarity.findBestMatch(domain, popularDomains)

  const isSuspicious = bestMatch.target !== domain && bestMatch.rating >= 0.7

  if (isSuspicious) {
    return `Можливо, ви мали на увазі: ${local}@${bestMatch.target}`
  }

  return true
}

// const url = value =>
//   value ? /https?:\/\/.+\..+/.test(value) || 'Необхідне повне посилання (URL)' : true;

export { required, counter, email }
